/* eslint-disable no-new */
import { memo, useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import {
  DEFAULT_LANGUAGE,
  GOOGLE_TRANSLATE_ELEMENT,
  GOOGLE_TRANSLATE_SCRIPT,
} from 'constants/googleTranslate';

import shouldShowBrandingInRoutes from 'utils/CompanyBranding/shouldShowBrandingInRoutes';
import { changeLanguage } from 'utils/GoogleTranslate/googleTranslateHelpers';

const GoogleTranslate = () => {
  const location = useLocation();
  const isAvailableTranslate = shouldShowBrandingInRoutes(location.pathname);
  const [googleTranslateScriptLoaded, setGoogleTranslateScriptLoaded] = useState(false);

  useEffect(() => {
    const scriptInDom = document.getElementById(GOOGLE_TRANSLATE_SCRIPT);
    if (isAvailableTranslate && !scriptInDom) {
      const script = document.createElement('script');
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = false;
      script.defer = false;
      script.id = GOOGLE_TRANSLATE_SCRIPT;
      document.body.appendChild(script);

      script.onload = () => {
        setGoogleTranslateScriptLoaded(true);
      };
    }

    if (!isAvailableTranslate && scriptInDom) {
      changeLanguage(DEFAULT_LANGUAGE);
    }
  }, [isAvailableTranslate]);

  useEffect(() => {
    if (googleTranslateScriptLoaded) {
      const interval = setInterval(() => {
        if (window.googleTranslateElementInit === undefined) {
          window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement({}, GOOGLE_TRANSLATE_ELEMENT);
          };
        } else {
          window.googleTranslateElementInit();
          clearInterval(interval);
        }
      }, 100);
    }
  }, [googleTranslateScriptLoaded]);

  return (<div id={GOOGLE_TRANSLATE_ELEMENT} />);
};

export default memo(GoogleTranslate);